import BaseServiceCrud from './BaseServiceCrud';

export default class EmailService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'email-template';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria.locale,
            email_type: criteria.emailType?.enumValue,
            description: criteria.description,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }
    getParameters(type, locale) {
        return this.fetch(`${this.domain}/${this.path}/emailType/${type}/${locale}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    get(emailTemplateId) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/${emailTemplateId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
